<template>
    <v-container fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="10">
                <v-card class="elevation-4">
                     <v-card-title>
                        Create Diet
                        <div class="flex-grow-1"></div>
                        <v-btn color="primary" @click="$router.push('/business/dietlist')">Diet List</v-btn>
                     </v-card-title>
                    <v-card-text>
                         <v-divider></v-divider>
                        <v-form v-model="valid" enctype="multipart/form-data" id="createDiet">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12">
                                        <h4 class="title">Diet Information</h4>
                                    </v-col>
                                </v-row>
                                
                                <v-row>
                                    <v-col cols="12" md="12">
                                        <v-text-field
                                        v-model="name"
                                        name="name"
                                        label="Diet Name"
                                        required
                                        v-validate="'required|max:255'"
                                        :error-messages="errors.collect('name')"
                                        data-vv-name="name"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>  

                                <v-divider></v-divider>
                                <div class="my-3">
                                <v-btn color="primary" @click="submit">Create Diet</v-btn>
                                </div>
                            </v-container>
                        </v-form>
                    </v-card-text>

                </v-card>
            </v-col>
        </v-row>
        
    </v-container>
    
</template>
<script>
import Vue from 'vue'
import VeeValidate from "vee-validate";

Vue.use(VeeValidate);
export default{

    props: 
    {
        source: String
    },
    data: () => ({
        valid: true,
        name:"",
        dictionary: 
        {
                    attributes: {
                        name: "Diet Name",
                    },
                    custom: {}
        }
    }),
    mounted() 
    {
        this.$validator.localize("en", this.dictionary);
    },
    methods: {
        submit() {
            let th = this;
            if (this.$validator.validateAll()) {
                let fd = new FormData(document.getElementById("createDiet"));
                
                this.$http
                .post(this.$apidomain+"business/createDiet", fd)
                .then(res => {
                    if(res.data.success)  
                    {
                    
                    
                     this.$router.push("/business/dietlist");
                    }  
                    else
                    {
                        let errmsg=[];
                        for(var prop in res.data.errors){
                            errmsg.push(res.data.errors[prop][0]);
                        }
                        alert(errmsg[0]);
                    }
                })
                .catch(err => {
                    console.log(err.response);
                });
            }
        }
}   
    
}
</script>